import { createContext } from "react";

export const IdInDocument = createContext(null);